<template>
  <van-list
    class="ul"
    :style="{ background: finished ? 'none' : 'background:#fff' }"
    v-model="loading"
    :finished="finished"
    @load="onLoad"
  >
    <li
      v-for="article in articleList"
      :key="article.id"
      @click="toDetail(article)"
    >
      <img :src="article.pic" alt="" style="width: 1.32rem; height: 0.87rem" />
      <div class="content">
        <div class="content_title">
          <h2><span v-if="article.top == 1">置顶</span>{{ article.title }}</h2>
        </div>
        <div class="time">
          <p>{{ article.ctime }}</p>
          <div class="see">
            <img
              src="../../assets/img/icon_read@2x.png"
              alt=""
              style="width: 0.12rem; height: 0.08rem"
            />
            <p>{{ article.view }}</p>
          </div>
        </div>
      </div>
    </li>
  </van-list>
</template>

<script>
import { getnewslist } from "../../api/home";
export default {
  props: ["typeId"],
  data() {
    return {
      articleList: [],
      loading: false,
      finished: false,
      page: 1,
    };
  },
  // activated() {
  //   getnewslist({ type_id: this.typeId }).then((res) => {
  //     this.articleList = res.data.backdata.lists;
  //   });
  // },
  created() {
    // this.$emit("isLoading", true);
    // getnewslist({ type_id: this.typeId, page: this.page })
    //   .then((res) => {
    //     this.articleList.push(res.data.backdata.lists);
    //     this.page += 1;
    //     this.$emit("isLoading", false);
    //   })
    //   .catch((err) => {
    //     this.$emit("isLoading", false);
    //   });
  },
  methods: {
    toDetail(val) {
      this.$router.push({
        name: "文章详情",
        params: {
          id: val.id,
          article: val,
        },
      });
    },
    onLoad() {
      this.loading = true;
      getnewslist({ type_id: this.typeId, page: this.page })
        .then((res) => {
          this.articleList.push(...res.data.backdata.lists);
          this.page += 1;
          this.loading = false;
          if (this.articleList.length >= res.data.ext.total) {
            this.finished = true;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.van-tabs__content {
  .van-tab__pane {
    .ul {
      padding: 0 0.17rem 0 0.15rem;
      li {
        display: flex;
        margin-top: 0.22rem;
        width: 100%;
        height: 0.87rem;
        .content {
          margin-left: 0.1rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .content_title {
            span {
              background: #f12727;
              border-radius: 0.02rem;
              text-align: center;
              line-height: 0.17rem;
              color: #ffffff;
              font-size: 0.125rem;
              margin-right: 0.03rem;
              display: inline-block;
              width: 0.425rem;
              height: 0.175rem;
              transform: scale(0.8);
            }
            h2 {
              font-size: 0.15rem;
              font-weight: bold;
              color: #343434;
              line-height: 0.19rem;
            }
          }
          .time {
            font-size: 0.12rem;
            color: #9a9a9c;
            line-height: 0.18rem;
            display: flex;
            align-items: center;
            .see {
              display: flex;
              align-items: center;
            }
            img {
              margin: 0 0.05rem 0 0.19rem;
            }
          }
        }
      }
    }
  }
}
</style>
